import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import { YMaps, GeolocationControl, Geolocation, Map, Placemark } from '@pbe/react-yandex-maps';
import AsyncSelect from 'react-select/async';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import {FormattedMessage} from 'react-intl';

export class ConfigCompany extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      company: {images: [], schemes: [], locationX: null, locationY: null},
      branches: [],
      branch: { id: 0 },
      geoposition: [55.558741, 37.378847],
      zoom: 14,
      selectedImage: 0,
      selectedScheme: 0,
      loading: true,
      companyId: parseInt(this.props.match.params.companyId) || 0,
      cities: [],
      city: null
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleGo = this.handleGo.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.geopositionSuccess = this.geopositionSuccess.bind(this);
    this.debouncedLoadOptions = this.debounce(this.fetchOptions, 1000);
  }

  componentDidMount() {
    this.populateCompaniesData();
  }

  updateCompanyName(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, name: val}}));
  }

  updateCompanyAddress(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, address: val}}));
  }

  updateCompanyDescription(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, description: val}}));
  }

  updateCompanyLocation(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, locationX: parseFloat(val.split(',')[0]), locationY: parseFloat(val.split(',')[1])}}));
  }

  async handleSave() {
    if (!this.state.company.name || this.state.company.name === '')
      return;
    const company = this.state.company;
    company.city = this.state.city;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.company.id}`, {
      method: "PUT",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(company)
    });
    await response.json();
  }

  async handleCreate() {
    if (!this.state.company.name || this.state.company.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.company)
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: data, companyId: data.id}));
  }

  async addImage(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/image`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, images: [...prevState.company.images, data]}, selectedImage: prevState.company.images.length}));
  }

  async addScheme(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/scheme`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, schemes: [...prevState.company.schemes, data]}, selectedScheme: prevState.company.schemes.length}));
  }

  async removeImage() {
    var selectedImage = this.state.selectedImage;
    this.setState(prevState => ({...prevState, selectedImage: -1}));
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/image/${selectedImage}`, {
      method: 'DELETE',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, images: data}, selectedImage: selectedImage >= data.length ? data.length - 1 : selectedImage}));
  }

  async upImage() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/image/${this.state.selectedImage}`, {
      method: 'PUT',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, images: data}, selectedImage: 0}));
  }

  async removeScheme() {
    var selectedScheme = this.state.selectedScheme;
    this.setState(prevState => ({...prevState, selectedScheme: -1}));
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/scheme/${selectedScheme}`, {
      method: 'DELETE',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, schemes: data}, selectedScheme: selectedScheme >= data.length ? data.length - 1 : selectedScheme}));
  }

  async upScheme() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/scheme/${this.state.selectedScheme}`, {
      method: 'PUT',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, schemes: data}, selectedScheme: 0}));
  }

  selectBranch(branch) {
    this.setState(prevState => ({...prevState, branch: branch}));
  }

  mapOnLoad(ymaps) {
    if (this.state.company.locationX === null || this.state.company.locationY === null) {
      navigator.geolocation.getCurrentPosition(this.geopositionSuccess, this.error);
    }
  };

  onGeoposition() {
    if (this.state.mapZoom != 14) {
      this.setState(prevState => ({...prevState, zoom: 13}));
    }
    navigator.geolocation.getCurrentPosition(this.geopositionSuccess, this.error);
  };

  geopositionSuccess(position) {
    this.setState(prevState => ({...prevState, zoom: 14, geoposition: [position.coords.latitude, position.coords.longitude], bounds: null}));
  }

  error() {
    console.log('geopositionError');
  }

  selectBounds(event) {
    var bounds = event.get('newBounds');
    var zoom = event.get('newZoom');
    console.log(bounds);
    console.log(zoom);
    this.setState(prevState => ({...prevState, mapBounds: bounds, mapZoom: zoom}));
  }

  selectPosition(geolocation) {
    this.setState(prevState => ({...prevState, company: {...prevState.company, locationX: geolocation.get('coords')[0], locationY: geolocation.get('coords')[1]}}));
  };

  selectCity(newValue) {
    const locationX = newValue.mapPositionX1+(newValue.mapPositionX2-newValue.mapPositionX1)/2;
    const locationY = newValue.mapPositionY1+(newValue.mapPositionY2-newValue.mapPositionY1)/2;
    this.setState(prevState => ({...prevState, city: newValue, zoom: 8, geoposition: [locationX, locationY], bounds: [[newValue.mapPositionX1, newValue.mapPositionY1],[newValue.mapPositionX2,newValue.mapPositionY2]]}));
  }

  handleGo() {
    if (this.state.company.locationX && this.state.company.locationY) {
      this.setState(prevState => ({...prevState, zoom: 14, geoposition: [this.state.company.locationX, this.state.company.locationY], bounds: null}));
    }
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);  
      }, delay);
    };
  };

  async fetchOptions(inputValue, callback) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/geo/city?filter=${encodeURIComponent(inputValue)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    const mapped = data.map(d=>({value: d.name, name: d.name, id: d.id, label: d.name, mapPositionX1: d.mapPositionX1, mapPositionY1: d.mapPositionY1, mapPositionX2: d.mapPositionX2, mapPositionY2: d.mapPositionY2}));
    this.setState(prevState => ({...prevState, cities: mapped}));
    callback(mapped);
  }

  render() {
    let buttons = this.state.company.id ? (
      <div>
        <div>
        <div className="rightcompdiv">
          <div class="form-group">
            <label for="Input_CompanyLoc">Место на карте</label>
            <div>
              <input style={{float: "left", width: "372px", marginRight: "5px"}} disabled class="form-control" type="text" id="Input_CompanyLoc" name="Input.CompanyLoc" value={this.state.company.locationX ? this.state.company.locationX.toString() + ',' + this.state.company.locationY.toString() : ''} onChange={evt => this.updateCompanyLocation(evt)}/>
              <input style={{margin: "0"}} class="btn btn-primary" type="button" value="Перейти" id="Button_Go" onClick={this.handleGo}/>
            </div>
          </div>
          <YMaps>
            <Map width={"100%"} height={"100%"} onLoad={ymaps => this.mapOnLoad(ymaps)} onBoundschange={event => this.selectBounds(event)} state={{center: this.state.geoposition, zoom: this.state.zoom, bounds: this.state.bounds}} onClick={(geolocation) => this.selectPosition(geolocation)}>
              {this.state.company.locationX !== null ? <Placemark geometry={[this.state.company.locationX, this.state.company.locationY]} />:<></>}
              <GeolocationControl options={{ float: "left" }}  onClick={() => this.onGeoposition()}/>
            </Map>
          </YMaps>
        </div>
        <div className="leftcompdiv" style={{maxHeight: "unset"}}>
          <div>Фотографии</div>
          <div className="imagesq schemecomp">
            {this.state.company.images.length > 0 ? <div className="removeimage" onClick={() => this.removeImage()}>X</div> : <></>}
            {this.state.selectedImage > 0 ? <div className="upimage" onClick={() => this.upImage()}>&uarr;</div> : <></>}
            {this.state.selectedImage >= 0 && this.state.selectedImage < this.state.company.images.length ? <img src={this.state.company.images[this.state.selectedImage]} alt="" class="schemecomp"/> : <></>}
          </div>
        </div></div>
        <table className="table table-pagination"><thead><tr>{Array.from(Array(this.state.company.images.length).keys()).map(pos => <th onClick={() => this.setState(prevState => ({...prevState, selectedImage: pos}))} className={this.state.selectedImage === pos?'react-calendar__tile--active':''}>{pos + 1}</th>)}</tr></thead></table>
        <div class="tablediv">
          <label for="image-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> <FormattedMessage id="upload_photo"/>
          </label>
          <input id="image-upload" onChange={this.addImage.bind(this)} type="file"/>
        </div>
        <div className="tabledivbig">
          <div class="form-group">
            <div>Схемы</div>
            <div className="imagesq schemecomp">
              {this.state.company.schemes.length > 0 ? <div className="removeimage" onClick={() => this.removeScheme()}>X</div> : <></>}
              {this.state.selectedScheme > 0 ? <div className="upimage" onClick={() => this.upScheme()}>&uarr;</div> : <></>}
              {this.state.selectedScheme >= 0 && this.state.selectedScheme < this.state.company.schemes.length ? <img src={this.state.company.schemes[this.state.selectedScheme]} alt="" class="schemecomp"/> : <></>}
            </div>
          </div>
          <table className="table table-pagination"><thead><tr>{Array.from(Array(this.state.company.schemes.length).keys()).map(pos => <th onClick={() => this.setState(prevState => ({...prevState, selectedScheme: pos}))} className={this.state.selectedScheme === pos?'react-calendar__tile--active':''}>{pos + 1}</th>)}</tr></thead></table>
          <div>
            <label for="scheme-upload" class="btn btn-primary">
              <i class="fa fa-cloud-upload"></i> <FormattedMessage id="upload_scheme"/>
            </label>
            <input id="scheme-upload" onChange={this.addScheme.bind(this)} type="file"/>
          </div>
        </div>
        <input class="btn btn-primary" type="button" value="Сохранить" id="Button_Save" onClick={this.handleSave}/>

        <div style={{display: "none"}}><div>Branches list</div>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {this.state.branches.map(branch =>
              <tr key={branch.id} onClick={() => this.selectBranch(branch)} class={this.state.branch.id === branch.id?'react-calendar__tile--active':''}>
                <td>{branch.name}</td>
              </tr>
            )}
          </tbody>
        </table></div>
      </div>
    ) : (
        <div>
          <div>
            <input style={{margin: "5px 5px 0 0"}} class="form-check-input" type="checkbox" id="Input_AcceptOffer" name="Input.AcceptOffer"
              checked={this.state.acceptOffer !== undefined ? this.state.onlineReservation : false}
              onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, acceptOffer: val}));}}
            />
            <label style={{display: "contents"}} for="Input_AcceptOffer">Я, действуя от имени указанной мной компании, подтверждаю достоверность внесенных данных и безоговорочно принимаю условия <a href="/companyoffer" target="_blank" rel="noopener noreferrer">Публичной оферты</a></label>
          </div>
          <div>
            <input class="btn btn-primary" disabled={!this.state.acceptOffer || !this.state.company.name} type="button" value="Зарегистрировать" id="Button_Create" onClick={this.handleCreate}/>
          </div>
        </div>
    );

  return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="company" />
        <div class="headerdiv">
          <h4 id="tabelLabel" class="leftheader">{this.state.company.id > 0 ? "Настройки" : "Регистрация"} компании</h4>
          {this.state.company.id > 0 ? <a class="text-dark btn-book nav-link" href={`/booking/${this.state.companyId}`}>Календарь компании</a> : <></>}
        </div>
        <div class="form-group">
          <label for="Input_CompanyName">Название</label>
          <input class="form-control" type="text" id="Input_CompanyName" name="Input.CompanyName" value={this.state.company.name} onChange={evt => this.updateCompanyName(evt)}/>
        </div>

        <div class="form-group" style={{overflow: "visible"}}>
          <label for="city">Город</label>
          <AsyncSelect
              className="formselect"
              classNamePrefix="select"
              cacheOptions
              defaultOptions={this.state.cities}
              placeholder="Search cities..."
              loadOptions={this.debouncedLoadOptions}
              noOptionsMessage={() => "No Cities Found"}
              onChange={(newValue) => this.selectCity(newValue)}
              value={this.state.city}
            />
        </div>

        <div class="form-group">
          <label for="Input_Address">Адрес</label>
          <input class="form-control" type="text" id="Input_Address" name="Input.Address" value={this.state.company.address} onChange={evt => this.updateCompanyAddress(evt)}/>
        </div>

        <div class="form-group">
          <label for="Input_CompanyDesc">Подробное описание</label>
          <ReactQuill class="form-control" id="Input_CompanyDesc" name="Input.CompanyDesc"
            value={this.state.company.description}
            onChange={val => {this.setState(prevState => ({...prevState, company: {...prevState.company, description: val}}));}}
          />
        </div>

        <div class="configgroup">
        <div class="availheader">Сведения о компании для оферты (заполняются один раз при регистрации компании)</div>
        <div class="form-group">
          <label for="Input_Type">Правовая форма</label>
          <Select
              className="formselect"
              classNamePrefix="select"
              isDisabled={false}
              isClearable={false}
              isSearchable={true}
              options={[{ value: "ИП", label: "ИП" }, { value: "ООО", label: "ООО" }, { value: "Физическое лицо", label: "Физическое лицо" }]}
              placeholder="Выберите правовую форму..."
              noOptionsMessage={() => "Поиск не дал результатов"}
              onChange={(newValue) => this.setState(prevState => ({...prevState, company: {...prevState.company, type: newValue.label}}))}
              value={this.state.company.type?{value: this.state.company.type, label: this.state.company.type}:null}
              name="Input_Type"
            />
        </div>
        {this.state.company.type === "ИП" || this.state.company.type === "ООО" ?
        <div class="form-group">
          <label for="Input_OfficialName">Наименование юридического лица</label>
          <input class="form-control" type="text" id="Input_OfficialName" name="Input.OfficialName" value={this.state.company.officialName}
            onChange={evt => this.setState(prevState => ({...prevState, company: {...prevState.company, officialName: evt.target.value}}))}/>
        </div>:<></>}
        <div class="form-group">
          <label for="Input_TIN">ИНН</label>
          <input class="form-control" type="text" id="Input_TIN" name="Input.TIN" value={this.state.company.tin}
            onChange={evt => this.setState(prevState => ({...prevState, company: {...prevState.company, tin: evt.target.value}}))}/>
        </div>
        {this.state.company.type === "Физическое лицо" || this.state.company.type === "ООО" ?
        <div class="form-group">
          <label for="Input_Leader">{this.state.company.type === "Физическое лицо" ? "ФИО полностью" : "ФИО руководителя"}</label>
          <input class="form-control" type="text" id="Input_Leader" name="Input.Leader" value={this.state.company.leader}
            onChange={evt => this.setState(prevState => ({...prevState, company: {...prevState.company, leader: evt.target.value}}))}/>
        </div>:<></>}
        {this.state.company.type ?
        <div class="form-group">
          <label for="Input_Document">{this.state.company.type === "Физическое лицо" ? "Паспортные данные" : (this.state.company.type === "ООО" ? "Основание полномочий" : "Свидетельство о регистрации (ОГРНИП)")}</label>
          <input class="form-control" type="text" id="Input_Document" name="Input.Document" disabled={this.state.company.type === "ООО"} value={this.state.company.type === "ООО" ? "устав" : this.state.company.document}
            onChange={evt => this.setState(prevState => ({...prevState, company: {...prevState.company, document: evt.target.value}}))}/>
        </div>:<></>}
        </div>
        {buttons}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateCompanyData(ownCompanies[0].id);
      }
    }
  }

  async populateCompanyData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok){
      return;
    }
    const data = await response.json();
    if (data.city) {
      data.city.value = data.city.name;
      data.city.label = data.city.name;
    }
    this.setState(prevState => ({...prevState, company: data}));
    if (data.locationX !== null && data.locationY !== null) {
      this.setState(prevState => ({...prevState, geoposition: [data.locationX, data.locationY], city: data.city, cities: [data.city]}));
    }
  }
}
